import { render, staticRenderFns } from "./ProposalDetails.vue?vue&type=template&id=05018e6c&scoped=true&"
import script from "./ProposalDetails.vue?vue&type=script&lang=js&"
export * from "./ProposalDetails.vue?vue&type=script&lang=js&"
import style0 from "./ProposalDetails.vue?vue&type=style&index=0&id=05018e6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05018e6c",
  null
  
)

export default component.exports